module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Roman.99cd70e0.woff";